// Modules
import cn from 'classnames';

// Types
import type { TCardBodyProps } from './Card.type';

// Styles
import styles from './styles.module.scss'

const CardBody = (props: TCardBodyProps) => {
	const {
		children,
		className,
		title,
		titleClassName,
		...restProps
	} = props

	const cardBodyCN = cn(styles.legion_card_body, className)
	const titleCN = cn(styles.body_title, titleClassName)

	return (
		<div className={cardBodyCN} {...restProps}>
			{title && (
				<p className={titleCN}>{title}</p>
			)}
			{children}
		</div>
	)
}

export default CardBody;
